import {put,takeEvery} from 'redux-saga/dist/redux-saga-effects-npm-proxy.esm';
import {TYPES as FORUM_COMMENT_TYPE} from '../creators/forums.comment';

import { select } from 'redux-saga/effects';
import history from "../libs/history";

const getCommentsTotal = (state) => state.forumComments.total;


export function* createSuccess(action) {
    try {
        yield put({type: "FORUM_COMMENTS_ADD", data : action.payload});
        let lastSegment = window.location.pathname.split("/").pop();
        const total = yield select(getCommentsTotal);
        let totalPage = parseInt(Math.ceil(total / 20));

        let currantPage = parseInt(lastSegment);
        if(totalPage >1 && currantPage !== totalPage){
            let url = window.location.pathname;
            url = currantPage > 1 ? url.replace("/"+lastSegment.toString(),"/"+totalPage.toString() ) : url+"/"+totalPage;
            history.push(url);

        }
        if(action.payload.isFollow){
            yield put({type: "FORUM_TOPIC_UPDATE_FOLLOW", data : action.payload});
        }


    } catch (error) {

    }
}

export function* deleteSuccess(action) {
    try {
        yield put({type: "FORUM_COMMENTS_DELETE", data : action.payload});
        let lastSegment = window.location.pathname.split("/").pop();
        const total = yield select(getCommentsTotal);
        let totalPage = parseInt(Math.ceil(total / 20));

        let currantPage = parseInt(lastSegment);
        if(totalPage >1 && currantPage !== totalPage && currantPage !== 0 ){
            let url = window.location.pathname;
            url = currantPage > 1 ? url.replace("/"+lastSegment.toString(),"/"+totalPage.toString() ) : url+"/"+totalPage;
            history.push(url);
        }

    } catch (error) {

    }
}

export function* updateSuccess(action) {
    try {
        yield put({type: "FORUM_COMMENTS_UPDATE", data : action.payload});
    } catch (error) {

    }
}

export function* watchTopicComment() {
    yield takeEvery(FORUM_COMMENT_TYPE.CREATE_SUCCESS, createSuccess);
    yield takeEvery(FORUM_COMMENT_TYPE.DELETE_SUCCESS, deleteSuccess);
    yield takeEvery(FORUM_COMMENT_TYPE.UPDATE_SUCCESS, updateSuccess);
}

export default watchTopicComment;

